import { Avatar, Container } from '@mui/material';
import { Outlet } from 'react-router-dom';
import { PublicHeader, Footer } from 'Components';
import { useIsDesktop } from 'Hooks';
import { BgDesk, BGDesktop, BgMobile } from 'Images';
export const EmergencyCallLayout = () => {
  const isDesktop = useIsDesktop();

  return (
    <div
      style={{
        backgroundImage: isDesktop ? `url(${BgDesk})` : `url(${BgMobile})`,
        backgroundSize: 'cover',
      }}
    >
      <Avatar
        src={BGDesktop}
        alt={''}
        sx={{
          width: '100vw',
          height: '100vh',
          position: 'absolute',
          top: 0,
          right: 0,
          left: 0,
        }}
      />
      <PublicHeader />
      <Container
        maxWidth={'lg'}
        sx={{
          overflow: 'hidden',
          minHeight: 'calc(100vh - 72px - 477px)',
          paddingX: isDesktop ? '' : '24px',
        }}
        component={'main'}
      >
        <Outlet />
      </Container>
      <Footer />
    </div>
  );
};
